import { render, staticRenderFns } from "./OpeningBalances3.vue?vue&type=template&id=54a9f37a&"
import script from "./OpeningBalances3.vue?vue&type=script&lang=js&"
export * from "./OpeningBalances3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports